<div class="w-100 h-100 bg-body-secondary position-absolute d-flex align-items-center justify-content-center">
  <div class="text-center">
    <h1>
      <i class="text-dark fa-solid fa-spinner fa-spin"></i>
    </h1>
    <h5 class="text-muted">Зареждане...</h5>
  </div>
</div>
